import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SentimentColor } from "src/features/conversation/Scale";
import { Box, Group, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { BifIconInformationCircle, OverlayTrigger, Tooltip } from "banafo-design-system";
const AiSentimentAnalysis = ({ sentiment, suggestion }) => {
    const { t } = useTranslation();
    const textColor = SentimentColor[sentiment];
    return (_jsxs(Box, { mb: "md", children: [_jsx(Title, { size: "h6", children: t('Overall.Sentiment_') }), _jsxs(Group, { align: "center", gap: "xxs", fz: "sm", children: [_jsx(Text, { span: true, c: textColor, children: sentiment }), suggestion && _jsx(OverlayTrigger, { placement: "top", overlay: _jsx(Tooltip, { id: "overall-sentiment", children: suggestion }), children: _jsx(BifIconInformationCircle, {}) })] })] }));
};
export default AiSentimentAnalysis;
